<script>
    import { ValueService } from '../../services/ValueService.js';

    /**
     * @type {{
     *     tag?: string,
     *     inx?: number,
     *     children?: import("svelte").Snippet,
     * }}
     */
    let { tag = 'dd', inx = 0, children } = $props();

    const allowedTags = {
        dd: 'dd',
        span: 'span',
    };
    const thisTag = $derived(allowedTags[ValueService.toStringSingleLine(tag)] ?? 'dd');
    const thisNumber = $derived(ValueService.toInt(inx));
</script>

<svelte:element this={thisTag} class="lyListValue {thisNumber % 2 ? 'lyListOdd' : 'lyListEven'} float-right">
    <span class="text-base">
        {@render children?.()}
    </span>
</svelte:element>
